import singleSimPageType from "./singleSimPageType";

//product
export const successFetchedSingleSimPage = (data) => ({
  type: singleSimPageType.SUCCESS_FETCHIED_SINGLE_SIM_PAGE,
  payload: data,
});
export const failureFetchedSingleSimPage = (data) => ({
  type: singleSimPageType.FAILURE_FETCHED_SINGLE_SIM_PAGE,
  errorMessage: data,
});
